const womensSizes = ["XS", "S", "M", "L", "XL"];
const mensSizes = ["S", "M", "L", "XL", "XXL"];
const denimSizes = ["25", "26", "27", "28", "29", "30", "31", "32"];
const mensTrouserSizes = ["29", "30", "31", "32", "33", "34", "36"];

const productSpecs = [
  {
    id: 1,
    file: "01-arc-slim-flex.jpg",
    sku: "FP-W-2112-OLV",
    name: "Arc slim flex",
    gender: "Women",
    category: "Pants",
    price: 139.95,
    material: "97% cotton, 3% elastane",
    fit: "Mid rise · slim tapered leg",
    origin: "See garment label for country of origin",
    description:
      "A softly tailored ankle-length trouser with a clean front and exceptional recovery for everyday movement.",
    tags: ["Stretch", "Everyday", "Pants"],
    size: womensSizes,
    colors: ["Olive", "Black"],
    colorHex: ["#6b7152", "#282828"],
    featured: true,
  },
  {
    id: 2,
    file: "02-lane-five-pocket-flex.jpg",
    sku: "FP-W-2055-SND",
    name: "Lane five-pocket flex",
    gender: "Women",
    category: "Pants",
    price: 139.95,
    material: "96% cotton, 4% elastane",
    fit: "Mid rise · straight slim leg",
    origin: "See garment label for country of origin",
    description:
      "A modern five-pocket trouser balancing a close line with the comfort of flexible cotton-blend twill.",
    tags: ["Stretch", "Five-pocket", "Pants"],
    size: womensSizes,
    colors: ["Warm Sand", "Navy"],
    colorHex: ["#c7baa5", "#27303a"],
    featured: true,
  },
  {
    id: 3,
    file: "03-fluid-layering-top.jpg",
    sku: "FP-W-1810-CRM",
    name: "Fluid layering top",
    gender: "Women",
    category: "T-Shirts & Tops",
    price: 89.95,
    material: "94% lyocell, 6% elastane",
    fit: "Close fit · hip length",
    origin: "See garment label for country of origin",
    description:
      "A fluid long-sleeve base layer with a refined neckline, designed to sit smoothly beneath tailoring and knitwear.",
    tags: ["Lyocell blend", "Layering", "New"],
    size: womensSizes,
    colors: ["Cream", "Ink"],
    colorHex: ["#e8e0d1", "#313840"],
    isNew: true,
  },
  {
    id: 4,
    file: "04-essential-crew-tee.jpg",
    sku: "FP-W-1402-WHT",
    name: "Essential crew tee",
    gender: "Women",
    category: "T-Shirts & Tops",
    price: 19.95,
    compareAt: 39.95,
    material: "100% cotton",
    fit: "Relaxed fit · regular length",
    origin: "See garment label for country of origin",
    description:
      "A quietly structured crew-neck tee in soft cotton jersey, cut for an easy line through the body.",
    tags: ["Cotton jersey", "Sale", "Everyday"],
    size: womensSizes,
    colors: ["Optic White", "Charcoal"],
    colorHex: ["#f2f1ed", "#4a4946"],
  },
  {
    id: 5,
    file: "05-milano-stripe-half-sleeve-knit.jpg",
    sku: "FP-W-1734-STR",
    name: "Milano stripe half-sleeve knit",
    gender: "Women",
    category: "Knitwear",
    price: 139.95,
    material: "100% cotton",
    fit: "Boxy fit · elbow sleeve",
    origin: "See garment label for country of origin",
    description:
      "A graphic half-sleeve knit with compact Milano stitch, crisp stripe placement and a smooth, substantial hand.",
    tags: ["Cotton knit", "Stripe", "New"],
    size: womensSizes,
    colors: ["Ecru / Ink", "Moss / Cream"],
    colorHex: ["#d8d0c0", "#70765b"],
    featured: true,
    isNew: true,
  },
  {
    id: 6,
    file: "06-lyocell-utility-blouse.jpg",
    sku: "FP-W-1888-MOS",
    name: "Lyocell utility blouse",
    gender: "Women",
    category: "Blouses",
    price: 89.95,
    compareAt: 119.95,
    material: "100% lyocell",
    fit: "Relaxed fit · curved hem",
    origin: "See garment label for country of origin",
    description:
      "A fluid utility blouse with understated patch pockets and a soft drape that works open or neatly buttoned.",
    tags: ["Lyocell", "Blouse", "Sale"],
    size: womensSizes,
    colors: ["Moss", "Midnight"],
    colorHex: ["#73775c", "#2d3440"],
  },
  {
    id: 7,
    file: "07-pale-wash-slim-jeans.jpg",
    sku: "FP-W-2201-LBL",
    name: "Pale wash slim jeans",
    gender: "Women",
    category: "Denim",
    price: 139.95,
    material: "98% cotton, 2% elastane",
    fit: "High rise · slim leg",
    origin: "See garment label for country of origin",
    description:
      "A slim everyday jean with a pale blue wash, classic five-pocket details and flexible stretch.",
    tags: ["Denim", "Slim fit", "Pale wash"],
    size: denimSizes,
    colors: ["Eco Bleach"],
    colorHex: ["#9cabb4"],
    featured: true,
  },
  {
    id: 8,
    file: "08-square-poplin-blouse.jpg",
    sku: "FP-W-1915-BLU",
    name: "Square poplin blouse",
    gender: "Women",
    category: "Blouses",
    price: 129.95,
    material: "100% cotton",
    fit: "Oversized · cropped box shape",
    origin: "See garment label for country of origin",
    description:
      "A crisp poplin blouse shaped with modern square volume, dropped shoulders and precise concealed finishing.",
    tags: ["Cotton poplin", "New", "Blouse"],
    size: womensSizes,
    colors: ["Cloud Blue", "White"],
    colorHex: ["#aebfc5", "#eceae5"],
    isNew: true,
  },
  {
    id: 9,
    file: "09-fine-merino-polo.jpg",
    sku: "FP-W-1672-RST",
    name: "Fine merino polo",
    gender: "Women",
    category: "Knitwear",
    price: 149.95,
    material: "100% merino wool",
    fit: "Regular fit · fine gauge",
    origin: "See garment label for country of origin",
    description:
      "A fine-gauge merino polo with a small open collar and a polished silhouette made for effortless layering.",
    tags: ["Merino wool", "Fine knit", "Polo"],
    size: womensSizes,
    colors: ["Rust", "Anthracite"],
    colorHex: ["#9d5e43", "#454542"],
    featured: true,
  },
  {
    id: 10,
    file: "10-relaxed-indigo-jeans.jpg",
    sku: "FP-W-2208-IND",
    name: "Relaxed indigo jeans",
    gender: "Women",
    category: "Denim",
    price: 139.95,
    material: "100% cotton denim",
    fit: "High rise · relaxed straight leg",
    origin: "See garment label for country of origin",
    description:
      "An easy straight jean in deep indigo, designed with a balanced high rise and subtle workwear-inspired details.",
    tags: ["Denim", "Straight fit", "Indigo"],
    size: denimSizes,
    colors: ["Rinse Indigo"],
    colorHex: ["#26384a"],
    featured: true,
  },
  {
    id: 11,
    file: "11-relaxed-stripe-crew.jpg",
    sku: "FP-W-1745-STR",
    name: "Relaxed stripe crew",
    gender: "Women",
    category: "Knitwear",
    price: 129.95,
    material: "100% cotton",
    fit: "Oversized · dropped shoulder",
    origin: "See garment label for country of origin",
    description:
      "A generous striped crew knit with dropped shoulders, weighty rib trims and an intentionally relaxed drape.",
    tags: ["Cotton knit", "Stripe", "New"],
    size: ["XS/S", "M/L", "XL/XXL"],
    colors: ["Ink / Ecru", "Olive / Sand"],
    colorHex: ["#313b45", "#74735e"],
    isNew: true,
  },
  {
    id: 12,
    file: "12-refined-straight-sweatpants.jpg",
    sku: "FP-W-1549-GRY",
    name: "Refined straight sweatpants",
    gender: "Women",
    category: "Sweatshirts",
    price: 99.95,
    material: "100% cotton jersey",
    fit: "Relaxed straight leg · mid rise",
    origin: "See garment label for country of origin",
    description:
      "A refined sweat pant in dense cotton jersey, with a clean straight leg and discreet drawcord waist.",
    tags: ["Cotton jersey", "Loungewear", "Everyday"],
    size: womensSizes,
    colors: ["Heather Grey", "Black"],
    colorHex: ["#aaa9a4", "#2d2d2c"],
  },
  {
    id: 13,
    file: "13-yarn-dyed-slub-tee.jpg",
    sku: "FP-M-1505-STR",
    name: "Yarn-dyed slub tee",
    gender: "Men",
    category: "T-Shirts",
    price: 45.98,
    material: "100% cotton",
    fit: "Regular fit · crew neck",
    origin: "See garment label for country of origin",
    description:
      "A breathable slub-cotton tee with a subtle yarn-dyed stripe and softly varied texture.",
    tags: ["Cotton jersey", "New", "Stripe"],
    size: mensSizes,
    colors: ["Ecru / Navy", "Sage / Cream"],
    colorHex: ["#dad3c5", "#899079"],
    featured: true,
    isNew: true,
  },
  {
    id: 14,
    file: "14-everyday-taper-chino.jpg",
    sku: "FP-M-2071-KHK",
    name: "Everyday taper chino",
    gender: "Men",
    category: "Pants",
    price: 139.95,
    material: "97% cotton, 3% elastane",
    fit: "Regular rise · tapered leg",
    origin: "See garment label for country of origin",
    description:
      "A precise everyday chino with a gently tapered leg, clean waistband and flexible cotton-blend twill.",
    tags: ["Stretch twill", "Chino", "Everyday"],
    size: mensTrouserSizes,
    colors: ["Khaki", "Ink"],
    colorHex: ["#837e67", "#2e3438"],
    featured: true,
  },
  {
    id: 15,
    file: "15-lightweight-summer-coat.jpg",
    sku: "FP-M-2320-STN",
    name: "Lightweight summer coat",
    gender: "Men",
    category: "Jackets & Coats",
    price: 299.95,
    material: "55% linen, 45% cotton",
    fit: "Relaxed tailored fit · knee length",
    origin: "See garment label for country of origin",
    description:
      "A lightly constructed summer coat with architectural lapels and an airy natural-fibre weave for transitional days.",
    tags: ["Linen", "New", "Outerwear"],
    size: mensSizes,
    colors: ["Warm Stone", "Graphite"],
    colorHex: ["#aaa08d", "#474a48"],
    featured: true,
    isNew: true,
  },
  {
    id: 16,
    file: "16-structured-stripe-crew.jpg",
    sku: "FP-M-1761-STR",
    name: "Structured stripe crew",
    gender: "Men",
    category: "Knitwear",
    price: 139.95,
    material: "100% cotton",
    fit: "Regular fit · substantial knit",
    origin: "See garment label for country of origin",
    description:
      "A compact striped crew knit with modern proportions, a smooth Milano stitch and softly structured shoulders.",
    tags: ["Cotton knit", "Stripe", "New"],
    size: mensSizes,
    colors: ["Navy / Ecru", "Moss / Charcoal"],
    colorHex: ["#333f4b", "#687059"],
    isNew: true,
  },
  {
    id: 17,
    file: "17-natural-cotton-crew.jpg",
    sku: "FP-M-1712-NAT",
    name: "Natural cotton crew",
    gender: "Men",
    category: "Knitwear",
    price: 129.95,
    material: "100% cotton",
    fit: "Regular fit · hip length",
    origin: "See garment label for country of origin",
    description:
      "A dependable mid-weight crew knit with a clean neckline, balanced rib trims and a naturally soft hand feel.",
    tags: ["Cotton knit", "Crew neck", "Everyday"],
    size: mensSizes,
    colors: ["Natural", "Deep Olive"],
    colorHex: ["#d2c8b5", "#515943"],
  },
  {
    id: 18,
    file: "18-relaxed-flex-jeans.jpg",
    sku: "FP-M-2227-MID",
    name: "Relaxed flex jeans",
    gender: "Men",
    category: "Denim",
    price: 83.95,
    compareAt: 139.95,
    material: "98% cotton, 2% elastane",
    fit: "Regular rise · relaxed tapered leg",
    origin: "See garment label for country of origin",
    description:
      "A relaxed tapered jean in versatile mid blue, engineered for comfort without losing an authentic denim look.",
    tags: ["Denim", "Tapered fit", "Sale"],
    size: mensTrouserSizes,
    colors: ["Mid Indigo"],
    colorHex: ["#536c7c"],
    featured: true,
  },
  {
    id: 19,
    file: "19-fine-rib-merino-crew.jpg",
    sku: "FP-M-1780-CHR",
    name: "Fine rib merino crew",
    gender: "Men",
    category: "Knitwear",
    price: 69.95,
    compareAt: 129.95,
    material: "100% merino wool",
    fit: "Close fit · fine rib",
    origin: "See garment label for country of origin",
    description:
      "A tactile rib-knit crew with subtle stretch, a neat collar and a close silhouette that layers without bulk.",
    tags: ["Merino wool", "Rib knit", "Sale"],
    size: mensSizes,
    colors: ["Charcoal", "Forest"],
    colorHex: ["#484947", "#3f4f42"],
  },
  {
    id: 20,
    file: "20-heavy-zip-hoodie.jpg",
    sku: "FP-M-1593-OLV",
    name: "Heavy zip hoodie",
    gender: "Men",
    category: "Sweatshirts",
    price: 64.95,
    compareAt: 129.95,
    material: "100% cotton fleece",
    fit: "Relaxed fit · full zip",
    origin: "See garment label for country of origin",
    description:
      "A substantial zip hoodie in brushed cotton fleece, finished with a clean two-way zip and low-profile pockets.",
    tags: ["Cotton fleece", "Zip hoodie", "Sale"],
    size: mensSizes,
    colors: ["Deep Olive", "Heather Grey"],
    colorHex: ["#505847", "#999995"],
    featured: true,
  },
  {
    id: 21,
    file: "21-washed-linen-city-shirt.jpg",
    sku: "FP-M-1932-NAT",
    name: "Washed linen city shirt",
    gender: "Men",
    category: "Shirts",
    price: 129.95,
    material: "100% linen",
    fit: "Regular relaxed fit",
    origin: "See garment label for country of origin",
    description:
      "A relaxed city shirt in washed linen, with a soft collar and understated utility-inspired chest pocket.",
    tags: ["Linen", "Shirt", "New"],
    size: mensSizes,
    colors: ["Natural", "Dusty Blue"],
    colorHex: ["#d1c6b1", "#758b92"],
    isNew: true,
  },
  {
    id: 22,
    file: "22-textured-cross-rib-crew.jpg",
    sku: "FP-M-1768-MOS",
    name: "Textured cross-rib crew",
    gender: "Men",
    category: "Knitwear",
    price: 129.95,
    material: "100% cotton",
    fit: "Regular fit · structured texture",
    origin: "See garment label for country of origin",
    description:
      "A textural cross-rib crew knit with a calm, architectural surface and comfortable weight for year-round wear.",
    tags: ["Cotton knit", "Textured", "Crew neck"],
    size: mensSizes,
    colors: ["Moss", "Oat"],
    colorHex: ["#737961", "#c6bda9"],
  },
  {
    id: 23,
    file: "23-cotton-twill-overshirt.jpg",
    sku: "FP-M-2371-INK",
    name: "Cotton twill overshirt",
    gender: "Men",
    category: "Jackets & Coats",
    price: 169.95,
    material: "100% cotton twill",
    fit: "Relaxed overshirt fit",
    origin: "See garment label for country of origin",
    description:
      "A versatile overshirt with considered workwear pockets, robust natural twill and room for light layering.",
    tags: ["Cotton twill", "New", "Outerwear"],
    size: mensSizes,
    colors: ["Ink", "Tobacco"],
    colorHex: ["#343c3f", "#8a684c"],
    featured: true,
    isNew: true,
  },
  {
    id: 24,
    file: "24-soft-shoulder-wool-blazer.jpg",
    sku: "FP-M-2420-CHR",
    name: "Soft-shoulder wool blazer",
    gender: "Men",
    category: "Jackets & Coats",
    price: 329.95,
    material: "100% virgin wool",
    fit: "Modern regular fit · two button",
    origin: "See garment label for country of origin",
    description:
      "A softly structured metropolitan blazer with a natural shoulder, half lining and easy movement through the body.",
    tags: ["Virgin wool", "Tailoring", "Blazer"],
    size: ["46", "48", "50", "52", "54", "56"],
    colors: ["Charcoal", "Deep Navy"],
    colorHex: ["#494a48", "#2d3742"],
    featured: true,
  },
];

const productData = productSpecs.map(
  ({ file, material, fit, origin, ...product }) => ({
    ...product,
    image: `/img/products/${file}`,
    images: [`/img/products/${file}`],
    attributes: {
      material,
      fit,
      origin,
      care:
        material.includes("wool") || material.includes("merino")
          ? "Hand wash cold and dry flat"
          : "Gentle wash at 30°C with similar colours",
    },
    inStock: true,
  })
);

export default productData;
